module.exports = __webpack_public_path__ + "img/circle.3d942f60.svg";